var dataJson = {
  "tabs": [
    {
      "title": "Alkuperäisen laskun&nbsp;eräpäivä",
      "content": {
        "title": "Olen saanut laskun",
        "feeText": "Mikäli maksat laskun eräpäivään mennessä, ei kuluja synny. Yleinen viivästyskorko on EKP:n asettama viitekorko, johon lisätään 7 % korkoa. Maksumuistutuskulut ovat enintään 5 €/maksumuistutus.",
        "feeNotification": "Ei merkintää luottorekisteriin.",
        "subtabs": [
          {
            "title": "Pystyn maksamaan",
            "content": "Kun maksat laskun eräpäivään mennessä, on kaikki kunnossa. Jos sinulla on mitä tahansa kysyttävää laskuun liittyen, älä epäröi ottaa yhteyttä. Aina iloisesti palveleva asiakaspalvelumme on paikalla sinua varten!",
          },
          {
            "title": "En pysty maksamaan",
            "content": "Tiedätkö jo nyt, ettet voi maksaa laskua eräpäivään mennessä? Ei hätää – selvitetään yhdessä, voisiko esimerkiksi eräpäivää siirtää.",
          }
        ]
      }
    },
    {
      "title": "Maksumuistutus",
      "content": {
        "title": "Olen saanut maksumuistutuksen",
        "feeText": "Yleinen viivästyskorko on EKP:n asettama viitekorko, johon lisätään 7 % korkoa. Maksumuistutuskulut ovat enintään 5 €/maksumuistutus.",
        "feeNotification": "Ei merkintää luottorekisteriin.",
        "subtabs": [
          {
            "title": "Olen jo maksanut",
            "content": "Jos sait maksumuistutuksen laskusta, jonka olet jo maksanut vähintään kahta arkipäivää maksumuistutuksen päiväystä aikaisemmin, tarkista viite- ja tilinumeroiden oikeellisuus. Jos ne täsmäävät, voit hävittää maksumuistutuksen. Huomioithan, että mikäli maksoit laskun myöhemmin kuin kahta arkipäivää maksumuistutuksen päivämäärää ennen, olet velvollinen maksamaan maksumuistutuksesta aiheutuneet kulut.",
          },
          {
            "title": "Voin maksaa",
            "content": "Saat asian hoidettua kuntoon maksamalla maksumuistutuksen kuluineen ja korkoineen viimeistään merkittynä eräpäivänä. Käytä maksaessasi maksumuistutukseen merkittyjä viite- ja tilitietoja. Viivästyskorkoa kertyy laskun eräpäivästä alkaen.",
          },
          {
            "title": "En pysty maksamaan",
            "content": "Jos et kykene maksamaan laskua ajallaan, ota BRANGin asiakaspalveluun yhteyttä. Katsotaan yhdessä, voidaanko eräpäivää siirtää tai voimmeko tehdä maksusuunnitelmaan muita tilanteessasi auttavia muutoksia. Laskua ei kannata missään nimessä vain jättää maksamatta, sillä se siirtyy perintään noin kahden viikon kuluttua ja aiheuttaa lisäkuluja. Viivästyskorkoa kertyy laskun eräpäivästä alkaen.",
          },
          {
            "title": "Lasku on mielestäni aiheeton",
            "content": "Mikäli sait mielestäsi aiheettoman laskun, ota yhteyttä BRANGiin. Kerro, miksi lasku on mielestäsi aiheeton tai virheellinen. Me selvitämme asiaa yhdessä laskuttavan yrityksen kanssa.",
          }
        ]
      }
    },
    {
      "title": "1.&nbsp;maksuvaatimus",
      "content": {
        "title": "Olen saanut perintäkirjeen",
        "feeText": "Viivästyskorkoa kertyy laskun eräpäivästä alkaen. Yleinen viivästyskorko on EKP:n asettama viitekorko, johon lisätään 7 % korkoa. Ensimmäisen perintäkirjeen eli maksuvaatimuksen kulut ovat enintään 14–50 € laskun koosta riippuen.",
        "feeNotification": "Ei merkintää luottorekisteriin.",
        "subtabs": [
          {
            "title": "Olen jo maksanut",
            "content": "Viisainta on vielä tarkistaa, että olet käyttänyt oikeita viite- ja tilitietoja sekä maksanut laskun lisäksi mahdolliset muistutuskulut.",
          },
          {
            "title": "Voin maksaa vain osan",
            "content": "Meidän tehtävänämme on olla tukenasi silloin, kun tarvitset joustoa. Ota yhteyttä ja katsotaan yhdessä, voisiko laskua maksaa esimerkiksi useammassa erässä tai siirtää eräpäivää sinulle paremmin sopivaan ajankohtaan.",
          },
          {
            "title": "En pysty maksamaan",
            "content": "Ehdottomasti huonoin vaihtoehto on olla tekemättä mitään. Silloin perintä jatkuu ja kulut kasvavat. Ota yhteyttä mahdollisimman pian: selvitetään yhdessä, voidaanko maksusuunnitelmaa muuttaa joustavammaksi. Monissa tapauksissa eräpäivää pystytään siirtämään kahdella viikolla eteenpäin.",
          },
        ]
      }
    },
    {
      "title": "2.&nbsp;maksuvaatimus",
      "content": {
        "title": "Olen saanut toisen perintäkirjeen",
        "feeText": "Viivästyskorkoa kertyy laskun eräpäivästä alkaen. Yleinen viivästyskorko on EKP:n asettama viitekorko, johon lisätään 7 % korkoa. Toisen perintäkirjeen eli maksuvaatimuksen kulut ovat enintään 7–25 € laskun koosta riippuen.",
        "feeNotification": "Ei merkintää luottorekisteriin.",
        "subtabs": [
          {
            "title": "Olen jo maksanut",
            "content": "Tarkista, että olet maksanut laskun ennen toisen maksuvaatimuksen päiväystä. Varmistathan, että olet maksanut koko summan kuluineen ja korkoineen oikeilla viite- ja tilitiedoilla. Mikäli olet maksanut vasta toisen maksuvaatimuksen päiväyksen jälkeen, jää maksettavaksesi vielä toisesta maksuvaatimuksesta syntyneet perintäkulut.",
          },
          {
            "title": "En pysty maksamaan",
            "content": "Tilanne on ajautunut harmillisen pitkälle ja esimerkiksi eräpäivän siirtäminen voi olla tässä vaiheessa jo hankalaa. Älä kuitenkaan hätäänny, vaan ota viimeistään nyt BRANGiin yhteyttä. Kenties voimme vielä tehdä asiallesi jotain. Huonoin vaihtoehto on olla tekemättä mitään, sillä silloin maksu siirtyy oikeudelliseen perintään, josta seuraa kuluja sekä mahdollisesti maksuhäiriömerkintä luottotietoihin. Osa saatavista voidaan siirtää suoraan ulosottoon.",
          },
        ]
      }
    },
    {
      "title": "Haaste",
      "content": {
        "title": "Olen saanut haasteen käräjäoikeudesta",
        "feeText": "Riidattomien velkomusasioiden oikeudenkäyntikulut ovat 50–160 € muun muassa velan suuruudesta riippuen. Summaan lisätään oikeudenkäyntimaksu 65 tai 86 €.",
        "feeNotification": "Merkintä luottorekisteriin.",
        "subtabs": [
          {
            "title": "Haaste",
            "content": "Sait haasteen, koska lasku on maksamatta etkä ole sopinut uutta maksusuunnitelmaa. Haastehakemus on lähetetty käräjäoikeuden käsiteltäväksi. Toimi annettujen ohjeiden mukaan 14 vuorokauden kuluessa – muussa tapauksessa seurauksena on maksuhäiriömerkintä ja velkaa voidaan periä tuomion saatuasi ulosotossa.",
          },
        ]
      }
    },
    {
      "title": "Tuomio",
      "content": {
        "title": "Olen saanut tuomion",
        "feeText": "Riidattomien velkomusasioiden oikeudenkäyntikulut ovat 50–160 € muun muassa velan suuruudesta riippuen. Summaan lisätään oikeudenkäyntimaksu 65 tai 86 €.",
        "feeNotification": "Merkintä luottorekisteriin.",
        "subtabs": [
          {
            "title": "Tuomio",
            "content": "Jos jätät reagoimatta haasteeseen, saat 14 päivän kuluttua haasteen tiedoksiannosta käräjäoikeudelta maksuhäiriömerkinnän luottotietoihin aiheuttavan tuomion. Tuomion seurauksena velkaasi voidaan periä ulosotossa.",
          },
        ]
      }
    },
    {
      "title": "Ulosotto",
      "content": {
        "title": "Olen saanut tuomion",
        "feeText": "Ulosotto veloittaa ulosottoon maksetusta suorituksesta tai lyhennyksestä 2,5–210 € maksetun summan koosta riippuen.",
        "feeNotification": "Maksuhäiriömerkintä.",
        "subtabs": [
          {
            "title": "Ulosotto",
            "content": "Saat vireilletuloilmoituksen ulosottomieheltä. Se sisältää velkaa koskevat tiedot sekä yhteystiedot jatkoselvittelyä varten. Nyt vaihtoehtoja on kaksi: voit maksaa velkaa vapaaehtoisesti tai tulojasi ja omaisuuttasi voidaan ulosmitata. Julkiset maksut, kuten esimerkiksi kunnallinen päivähoito tai liikennevakuutus, siirtyvät suoraan ulosottoon.",
          },
        ]
      }
    },
  ]
}

populateTabHeaders(dataJson);
populateTabContents(dataJson);
populateAccordion(dataJson);

function populateTabHeaders(data){
var tabs = data["tabs"];

for (let i = 0; i < tabs.length; i++) {
  var activationState = '';
  if (i === 0){
    activationState = 'active';
  }
  jQuery('#tab-container').append('<a class="tab ' + activationState + '" data-tab="'+ i +'">'+ tabs[i]["title"] +'</a>')
}
}

function populateTabContents(data){
var tabs = data["tabs"];

// loop through tab contents
for (let i = 0; i < tabs.length; i++) {
  var subtabContainer = '';
  var subtabContents = '';

  // check for subtabs and save to variable
  if (tabs[i]["content"]["subtabs"].length > 0){
    for (let s = 0; s < tabs[i]["content"]["subtabs"].length; s++){
      var subtabActivation = '';
      if (s === 0 && i === 0){
        subtabActivation = ' active';
      }

      subtabContainer += '<a class="subtab' + subtabActivation + '" data-tab="'+ i +'" data-subtab="'+ s +'">'+ tabs[i]["content"]["subtabs"][s]["title"] +'</a>'
      subtabContents += '<div class="subtab-content" data-tab="'+ i +'" data-subtab="'+ s +'">'+ tabs[i]["content"]["subtabs"][s]["content"] +'</div>';
    }
  }

  var feeArea = '<div class="grid-x"><div class="cell small-12"><div class="fee-container"><strong>KULUT:</strong> ' +
  tabs[i]["content"]["feeText"] + '</div></div><div class="cell small-12"><div class="fee-notification"><p>' + tabs[i]["content"]["feeNotification"] + '</p></div></div></div>';

  jQuery('#tab-content-container').append('<div class="tab-content" data-tab="'+ i +'"><div class="tab-header"><h3>' +
  tabs[i]["content"]["title"]+'</h3></div><div class="subtab-container">' + subtabContainer +
  '</div>' + subtabContents + feeArea +'</div>');
}
}

function populateAccordion(data){
  var tabs = data["tabs"];
  var accordionItems = "";
  var itemActivation = false;
  var subitemActivation = true;

  for (let i = 0; i < tabs.length; i++) {
    // single accordion item html
    var accordionSubItems = "";

    // subtabs for the item
    for (let s = 0; s < tabs[i]["content"]["subtabs"].length; s++){

      if (subitemActivation === false){
        var activation = 'is-active';
        subitemActivation = true;
      }
      else {
        var activation = '';
      }
      accordionSubItems += '<li class="accordion-item ' + activation + '" data-accordion-item><a class="accordion-title">'+tabs[i]["content"]["subtabs"][s]["title"]+'</a><div class="accordion-content" data-tab-content><p class="text-left">'+tabs[i]["content"]["subtabs"][s]["content"]+'</p></div></li>'
    }

    if (itemActivation === false){
      var mainActivation = 'is-active';
      itemActivation = true;
    }
    else {
      var mainActivation = '';
    }

    var accordionItem = '<li class="accordion-item '+mainActivation+'" data-accordion-item><a class="accordion-title top-level">'+tabs[i]["title"]+'</a><div class="accordion-content" data-tab-content><h4 class="accordion-sub-title">'+tabs[i]["content"]["title"]+'</h4><ul class="accordion" data-accordion>'+accordionSubItems+'</ul><div class="grid-x"><div class="cell small-12"><div class="fee-container" style="margin:1rem 0;"><strong>KULUT:</strong> '+tabs[i]["content"]["feeText"]+'</div></div><div class="cell small-12"><div class="fee-notification-accordion"><p>'+tabs[i]["content"]["feeNotification"]+'</p></div></div></div></div></li>'

    accordionItems += accordionItem;
  }

  var accordionHtml = '<ul id="accordion" class="accordion" data-accordion>'+accordionItems+'</ul>'
  jQuery('#accordion').append(accordionHtml);
}

var tab = jQuery(".tab");
checkTabActivation(tab);

tab.click(function(e){
  e.preventDefault;
  setActiveTab(jQuery(this), tab);
  checkTabActivation(tab);
})

function setActiveTab(clickedElem, tab){
  tab.each(function(){
    if(jQuery(this).hasClass('active')){
      jQuery(this).removeClass('active');
    }
  });
  if (clickedElem.hasClass('active')){

  } else {
    clickedElem.addClass('active');
  }
};

function checkTabActivation(tab){
  jQuery('.tab-content').hide();
  var tabNumber;
  tab.each(function(){
    if (jQuery(this).hasClass('active')){
      tabNumber = jQuery(this).data('tab');
      // break out of loop if active tab is found
      return false;
    }
  });

  jQuery('.tab-content[data-tab='+ tabNumber +']').show();

  var subtab = jQuery(".subtab");

  setActiveSubtab(jQuery('.subtab[data-tab="'+ tabNumber +'"][data-subtab="0"]'), subtab);
  checkSubtabActivation(subtab);
}

// Subtab functionality

var subtab = jQuery(".subtab");

checkSubtabActivation(subtab);

subtab.click(function(e){
  e.preventDefault;
  setActiveSubtab(jQuery(this), subtab);
  checkSubtabActivation(subtab);
})

function setActiveSubtab(clickedElem, subtab){
  subtab.each(function(){
    if(jQuery(this).hasClass('active')){
      jQuery(this).removeClass('active');
    }
  });
  if (clickedElem.hasClass('active')){

  } else {
    clickedElem.addClass('active');
  }
};

function checkSubtabActivation(subtab){
  jQuery('.subtab-content').hide();
  var subtabNumber;
  subtab.each(function(){
    if (jQuery(this).hasClass('active')){
      subtabNumber = jQuery(this).data('subtab');
      // break out of loop if active subtab is found

      return false;
    }
  });

  jQuery('.subtab-content[data-subtab='+ subtabNumber +']').show();
}

jQuery("#accordion").on("up.zf.accordion", function(event) {
    setTimeout(function(){
        jQuery('html,body').animate({scrollTop: jQuery('#accordion>.is-active').offset().top}, 'slow');
    }, 250); //Adjust to match slideSpeed
});
